import Breadcrumbs from "@/components/breadcrumb";
import {Layout} from "@/components/layout";
import Container from "@/components/ui/container";
import {ProgrammationRadioLive} from "@/components/programmation";
import {Button} from "@/components/ui/button";
import Link from "next/link";
import {Separator} from "@/components/ui/separator";
import {FrequencyTable} from "@/components/frequency";
import {OurPodcast} from "@/components/podcast";
import {GetStaticPropsResult} from "next";
import {DrupalNode} from "next-drupal";
import {getFavorites, getPromotedPodcasts, getTeamMembers} from "@/lib/drupalFetcher";
import {SliderFavorites} from "@/components/favorites";
import {HeadMetadata} from "@/components/headMetadata";
import React from "react";
import {CKoiLeTitre} from "@/components/cKoiLeTitre";
import {EquipeSlider} from "@/components/equipe";
import {HistoireRadioBannerComponent} from "@/components/banner";

export interface FavoritesPageProps {
  nodes: DrupalNode[]
  favoritesNodes: DrupalNode[]
  teamMembers: DrupalNode[]
}

export default function RadioPage({nodes, favoritesNodes, teamMembers}) {
  const breadcrumb = [
    {label: 'la radio' }
  ];

  return (
    <Layout>
      <HeadMetadata
        title="La radio"
        description="Découvrez l'univers de RRB, où la musique rencontre la parole. Explorez nos derniers podcasts, trouvez nos fréquences et partez à la découverte de vos titres préférés."
      />

      <Container>
        <Breadcrumbs entries={breadcrumb}/>

        <h1 className="mb-2 text-[40px] text-foreground-dark">La radio</h1>

        <p className='text-foreground-light mb-3'>Découvrez l&apos;univers de RRB, où la musique rencontre la parole. Explorez nos derniers podcasts, trouvez nos fréquences et partez à la découverte de vos titres préférés.</p>

        <Separator className='mt-3 mb-12'/>

      </Container>

      <ProgrammationRadioLive />

      <Container className="py-10">

        <div className="flex max-md:flex-col justify-center text-center">
          <Button className="justify-self-center" asChild>
            <Link href="/programmation">
              Voir la grille des programmes
            </Link>
          </Button>
        </div>

        <FrequencyTable/>
      </Container>

      <div className="bg-brand-mer-900 my-5 py-8">
        <OurPodcast nodes={nodes}/>
      </div>

      <Container className="py-10">

        <div className="grid md:grid-cols-10">
          <div className="col-start-2 col-end-10">

            <CKoiLeTitre/>

            {/*<div className="mt-10 py-4">*/}
            {/*  <HistoireRadioBannerComponent/>*/}
            {/*</div>*/}

          </div>
        </div>
      </Container>

      <SliderFavorites nodes={favoritesNodes}/>

      <EquipeSlider nodes={teamMembers}/>

    </Layout>
)
}

export async function getServerSideProps(context): Promise<GetStaticPropsResult<FavoritesPageProps>> {
  context.res.setHeader(
    'Cache-Control',
    'public, s-maxage=3600, stale-while-revalidate=3599, max-age=3600'
  )
  const nodes: DrupalNode[] = await getPromotedPodcasts(context);
  const favoritesNodes: DrupalNode[] = await getFavorites(context);
  const teamMembers: DrupalNode[] = await getTeamMembers(context);

  return {
    props: {
      nodes,
      favoritesNodes,
      teamMembers
    }
  }
}